import React, { useState } from "react";
import { Frame, ScalingContainer, Header } from "../../../AppStyled";
import { Button } from "./SecondPage";

export default function Guide({
  unBlur,
  scrollable,
  h,
  handleAbove,
  userSettings,
}) {
  const [animSG, setanimSG] = useState(false);

  return (
    <Frame
      className="BetReplayFrame"
      opacity="true"
      unBlur={unBlur}
      scrollable={scrollable}
    >
      <ScalingContainer className="ScalingContainer" h={h}>
        <Header
          name="BET REPLY"
          userSettings={userSettings}
          handleAbove={handleAbove}
        />
        <Button
          onClick={() => {
            // if (sound) confirm();
            setanimSG(true);
            setTimeout(() => {
              handleAbove("provFair");
            }, 500);
          }}
          animSG={animSG}
        >
          <div className="yellow" />
          <div className="white" />
          Guide
        </Button>
      </ScalingContainer>
    </Frame>
  );
}
